$(function() {
    
    $('body.page-dateiupload').find('.page-content p').each(function() {
        if ($(this).find('img').length > 1) {
            var imgs = [];
            var $swiper = $('<div class="swiper"></div>');
            var $swiperContainer = $('<div class="swiper-container"></div>');
            var $swiperWrapper = $('<div class="swiper-wrapper"></div>');
            var $swiperPagination = $('<div class="swiper-pagination"></div>');
            var $swiperBtnPrev = $('<div class="swiper-button-prev"></div>');
            var $swiperBtnNext = $('<div class="swiper-button-next"></div>');
            $(this).find('img').each(function() {
                var $swiperSlide = $('<div class="swiper-slide"><figure></figure></div>');
                $swiperSlide.find('figure').append($(this));
                $swiperWrapper.append($swiperSlide);
            });
            $swiperContainer.append($swiperWrapper);
            $swiper.append($swiperContainer);
            $swiper.append($swiperPagination);
            $swiper.append($swiperBtnPrev);
            $swiper.append($swiperBtnNext);
            $(this).replaceWith($swiper);
            var mySwiper = new Swiper ($swiperContainer[0], {
                direction: 'horizontal',
                loop: true,
                autoHeight: true, 
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets',
                }
            })
        }
    });

});